
export interface EvaluationsCoachingData {
    score: number;
    rawScore: number;
    maxPossibleScore: number;
    // for coaching events this is when the coaching was completed {{CompletionTime: string;}}: they are the same field so i can sort them in the back end
    dateRecieved: string;
    agent: string;
    dateGroup: string;
    segmentContactID: string;
    segmentID: StaticRange;
    workflowInstanceID: string;
    workflowStatus: string;
    changeFormAllowed: boolean;
    scoringVisible: boolean;
    preferScoreOverRank: boolean;
    evaluationSubject: string;

    assignee: string;
    assigneeStatus: string;
    assigner: string;
    coachingPackageName: string;
    coachingPlanId: string;
    coachingPlanName: string;
};

export interface AgentDropdown {
    name: string;
    id: number;
    dtoID: number;
    selected: boolean;
    color: string;
    hasData: boolean;
}

export class AgentData {
    name: string;
    avgScore: AvgScoreInfo[] = [];
    scores: ScoresObj[] = [];
    coachings: CoachingObj[] = [];
    coachingPoint: CoachingPoint[] = [];
}

export interface AvgScoreInfo { // evalPoint
    date: string; // x
    avgScore: number; // y
    numEvals: number;
}

export interface CoachingPoint {
    x: number;
    y: number;
    numCoachings: string;
}

export interface ScoresObj {
    date: string;
    score: number;
    rawScore: number;
    maxPossibleScore: number;
    shortDate: string;
    segmentContactID: string;
    segmentID: StaticRange; // why this type?
    workflowInstanceID: string;
    workflowStatus: string;
    changeFormAllowed: boolean;
    scoringVisible: boolean;
    preferScoreOverRank: boolean;
    evaluationSubject: string;
}

export interface CoachingObj {
    avgScore: number;
    coachingName: string;
    date: string;
    shortDate: string;
}

export interface PointObject {
    x: string | number;
    y: string | number;
    hasTooltip: boolean; // you can add custom data to a point object and reference it via series.chart.series.data
    dataLabels: [{ useHTML: boolean; format: string; color?: string; x?: number; y?: number }]; // this is an object that can be found from highcharts documentation
    marker: { symbol: string; width: number; height: number};  // this is an object that can be found from highcharts documentation
    className: string;
}

export interface NearestPointInfo {
    nearestPointAvg: number;
    idxOfNonNull: number;
}
